export const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return 'https://api.k-capital.com.au';
  }
  return 'http://localhost:5001';
};
